import { ShippingCountryOptions } from "../../../types/components";
import countries from "i18n-iso-countries";
import enLocale from "i18n-iso-countries/langs/en.json";
import elLocale from "i18n-iso-countries/langs/el.json";

countries.registerLocale(enLocale);
countries.registerLocale(elLocale);

const SUPPORTED_LANGS = new Set(["en", "el"]);

export const EUROPEAN_COUNTRY_CODES = new Set([
  "AL", "AD", "AT", "BY", "BE", "BA", "BG", "HR", "CY", "CZ",
  "DK", "EE", "FI", "FR", "DE", "HU", "IS", "IE", "IT",
  "XK", "LV", "LI", "LT", "LU", "MT", "MD", "MC", "ME", "NL",
  "MK", "NO", "PL", "PT", "RO", "RU", "SM", "RS", "SK", "SI",
  "ES", "SE", "CH", "UA", "GB", "VA",
]);

export function getCountryOptions(lang: string): ShippingCountryOptions[] {
  const resolvedLang = SUPPORTED_LANGS.has(lang) ? lang : "en";
  return Object.entries(countries.getNames(resolvedLang, { select: "official" }))
    .map(([code, name]) => {
      const isGreece = code === "GR";
      const isEurope = EUROPEAN_COUNTRY_CODES.has(code);
      return {
        value: code,
        label: name,
        isGreece,
        isEurope,
        isROW: !isGreece && !isEurope,
      };
    })
    .sort((a, b) => a.label.localeCompare(b.label, resolvedLang));
}